const loadCatalogs = async locale => {
  try {
    const catalog = await import(
      /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
      `../../../../.locale-client/${locale}/messages.js`
    )
    const catalogs = {
      [locale]: catalog.default,
    }

    return catalogs
  } catch (error) {
    /* eslint-disable no-console */
    if (typeof locale === 'undefined') {
      console.error('Expected `locale` to be String')
    }

    console.error(error)
    return {}
  }
}

export default loadCatalogs
